import { connect } from '@collaborator/npm_modules/dist/components/redux';
import { bindActionCreators } from 'redux';
import { REDUCER_CHAT_MODAL_NAME } from 'moduleChat/modules/modal/constants';
import React, { lazy, Suspense } from 'react';
import { Modal } from '@collaborator/npm_modules/dist/components/modal';
import { chatModalHide } from 'moduleChat/modules/modal/actions/hide';
import { reducerChatModal } from 'moduleChat/modules/modal/reducers';
var Thread = /*#__PURE__*/lazy(function () {
  return import('moduleChatThread/containers/Thread');
});

var ChatModal = function ChatModal(_ref) {
  var isVisible = _ref.isVisible,
      creUserId = _ref.creUserId,
      dealId = _ref.dealId,
      hide = _ref.hide;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Modal, {
    show: isVisible,
    onHide: hide,
    size: "lg",
    centered: true
  }, /*#__PURE__*/React.createElement(Modal.Title, {
    onHide: hide
  }), /*#__PURE__*/React.createElement(Modal.Body, {
    className: "d-flex h-700p modal__body_extended mb-0"
  }, /*#__PURE__*/React.createElement(Suspense, {
    fallback: ""
  }, /*#__PURE__*/React.createElement(Thread, {
    creUserId: creUserId,
    dealId: dealId
  })))));
};

export default connect(ChatModal, {
  reducers: [{
    name: REDUCER_CHAT_MODAL_NAME,
    reducer: reducerChatModal
  }],
  mapStateToProps: function mapStateToProps(state) {
    return state[REDUCER_CHAT_MODAL_NAME];
  },
  mapDispatchToProps: function mapDispatchToProps(dispatch) {
    return bindActionCreators({
      hide: chatModalHide
    }, dispatch);
  }
});